export default "__VITE_PUBLIC_ASSET__85e002f2__"